<template>
  <div class="list-main">
    <div
      v-for="(item, index) in props.contentList"
      :key="index"
      class="list-with-image"
    >
      <a :href="item.url">
        <div class="list-with-image-content">
          <div class="list-with-image-content-left">
            <div class="list-with-image-content-left-image">
              <img :src="item.coverImageUrl" />
            </div>
          </div>
          <div class="list-with-image-content-right">
            <div class="list-with-image-content-right-title link-style">
              {{ item.title }}
            </div>
            <div class="list-with-image-content-right-digest link-style">
              {{ item.digest }}
            </div>
            <div class="list-with-image-content-right-btn">
              <span class="date-read">
                <span class="date">
                  {{
                    new Date(item.publishTime).getFullYear() +
                    '.' +
                    (new Date(item.publishTime).getMonth() + 1) +
                    '.' +
                    new Date(item.publishTime).getDate()
                  }}
                </span>
                <span class="read">
                  <span class="read-eye"></span>
                  {{ item.readCount }}
                </span>
              </span>

              <span class="btn"> 详细+ </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script setup>
// #region 引用

// #endregion

// #region props/emit
const props = defineProps({
  contentList: {
    type: Array,
    default: () => [],
  },
});
// #endregion

// #region 变量/常量

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

// #endregion
</script>
<style scoped lang="scss">
@media screen and (device-width >= 1180px) {
  .list-with-image {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-bottom: 1px solid #ccc;
    &:hover {
      border-bottom: 1px solid #ccc;
      .list-with-image-content-left-image img {
        transform: translateX(5px);
      }
    }
    .link-style {
      position: relative;
      display: inline-block;
      padding: 4px 8px;
      font-size: 18px;
      text-decoration: none;
      transition:
        color 0.3s ease,
        transform 0.2s ease;
    }

    /* 下划线效果 */
    .link-style::after {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 0;
      height: 2px;
      content: '';
      background-color: #1a4a8e; /* 浙大红点缀 */
      transition: width 0.3s ease; /* 滑入效果 */
    }

    /* 悬停状态 */
    .link-style:hover {
      color: #1a4a8e !important; /* 浙大蓝 */
      text-shadow: 0 1px 2px rgb(0 0 0 / 10%); /* 可选：添加阴影增强点击感 */
      // transform: translateX(5px) scale(1.05); /* 轻微上浮+放大 */
    }

    .link-style:hover::after {
      display: flex;
      width: 100%; /* 下划线展开 */
      max-width: 100%;
    }

    .list-with-image-content {
      display: flex;
      margin: 10px 0;
    }

    .list-with-image-content-left {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 212px;
      .list-with-image-content-left-image {
        width: 200px;
        height: 124px;
        transition: all 1s ease;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border: none;
          border-radius: 5px;
          transition: all 1s ease;
        }
      }
    }

    .list-with-image-content-right {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      margin-left: 20px;

      &:hover {
        // .list-with-image-content-right-title,
        // .list-with-image-content-right-digest {
        //   transform: translateX(5px);
        // }
        // .list-with-image-content-right-btn .btn {
        //   color: #fff;
        //   background: #008bd5;
        // }
      }

      .list-with-image-content-right-digest {
        flex: 1;
        overflow: hidden;
        font-size: 14px;
        line-height: 22px;
        color: #8c8c8c;
      }

      .list-with-image-content-right-title {
        display: -webkit-box;
        overflow: hidden;
        font-size: 20px;
        line-height: 40px;
        color: #333;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        transition: all 1s ease;
        -webkit-box-orient: vertical;
      }

      .list-with-image-content-right-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .date-read {
          display: flex;
          gap: 100px;
          align-items: center;
          .date {
            font-size: 14px;
            line-height: 22px;
            color: #8c8c8c;
          }
          .read {
            display: flex;
            gap: 5px;
            align-items: center;
            font-size: 14px;
            line-height: 22px;
            color: #8c8c8c;
            .read-eye {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url('./image/eye.png') no-repeat;
              background-size: cover;
            }
          }
        }
        .btn {
          display: inline-block;
          width: 80px;
          height: 32px;
          margin: 0 10px 0 0;
          font-size: 14px;
          line-height: 32px;
          color: #8c8c8c;
          text-align: center;
          background: #fff;
          border-radius: 5px;
          box-shadow: 0 0 5px 0 #bbb9b9;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
@media screen and (device-width <= 1180px) {
  .list-with-image {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;

    .list-with-image-content {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #ccc;
    }

    .list-with-image-content-left {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 48vw;

      .list-with-image-content-left-image {
        width: 100%;
        height: 48vw;
        transition: all 1s ease;

        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
          transition: all 1s ease;
        }
      }
    }
    .list-with-image-content-right {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      margin-left: 1vw;
    }

    .list-with-image-content-right-digest {
      display: -webkit-box; /* 对于旧版WebKit浏览器（如旧版Safari和Android WebView） */
      overflow: hidden; /* 隐藏超出部分 */
      font-size: 4vw;
      line-height: 1.5em;
      color: #8c8c8c;
      text-overflow: ellipsis; /* 用省略号代替超出部分 */
      -webkit-line-clamp: 2; /* 限制显示的行数 */
      word-wrap: break-word; /* 防止长单词或URL无法换行 */
      white-space: normal; /* 允许文本换行 */
      -webkit-box-orient: vertical; /* 设置盒子为垂直方向 */
    }

    .list-with-image-content-right-title {
      margin: 3vw 0;
      overflow: hidden;
      font-size: 4.5vw;
      font-weight: 700;
      line-height: 1.5em;
      color: #333;
      transition: all 1s ease;
      -webkit-box-orient: vertical;
    }

    .list-with-image-content-right-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-right: 2vw;
      .date-read {
        display: flex;
        gap: 20px;
        align-items: center;
        .date {
          font-size: 14px;
          line-height: 22px;
          color: #8c8c8c;
        }
        .read {
          display: flex;
          gap: 5px;
          align-items: center;
          font-size: 14px;
          line-height: 22px;
          color: #8c8c8c;
          .read-eye {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url('./image/eye.png') no-repeat;
            background-size: cover;
          }
        }
      }
      .btn {
        display: inline-block;
        padding: 4px 12px;
        margin: 0 2.5vw 3vw 0;
        font-size: 14px;
        line-height: 2;
        color: #8c8c8c;
        text-align: center;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 2.5vw 0 #bbb9b9;
      }
    }
  }
}
</style>
